var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoShow"},[(_vm.unfold)?_c('div',{staticClass:"unfold"},[_vm._m(0),_c('router-link',{attrs:{"to":{ name: 'newsDetails', query: {
        id: _vm.id,
        module: 'industryInfo'
      }}}},[_c('img',{directives:[{name:"handle-img",rawName:"v-handle-img",value:(_vm.$store.state.api + _vm.src),expression:"$store.state.api + src"}],attrs:{"src":_vm.img,"alt":"安评应急培训"}})]),_c('div',[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.summary))])])],1):_c('div',{staticClass:"shrink"},[_vm._m(1),_c('router-link',{attrs:{"to":{ name: 'newsDetails', query: {
        id: _vm.id,
        module: 'industryInfo'
      }}}},[_vm._v(" "+_vm._s(_vm.summary)+" ")]),_c('span',[_vm._v(_vm._s(_vm.date))])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i')])
},function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i')])
}]

export { render, staticRenderFns }